import React, { FC, MouseEventHandler } from "react"

import "./PlayButton.scss"

export enum PLAY_BUTTON_VARIANTS {
  DEFAULT = "DEFAULT",
  OUTLINE = "OUTLINE",
}

export enum PLAY_BUTTON_SIZES {
  XS = "XS",
  S = "S",
  M = "M",
  L = "L",
}

export const PLAY_BUTTON_SIZES_DIMENSIONS: { [k in PLAY_BUTTON_SIZES]: number } = {
  XS: 20,
  S: 40,
  M: 56,
  L: 96,
}

export const PLAY_BUTTON_SVG_ASPECT_RATIO = 0.364

export type PlayButtonProps = {
  onClick?: MouseEventHandler,
  size?: keyof typeof PLAY_BUTTON_SIZES,
  variant?: keyof typeof PLAY_BUTTON_VARIANTS,
}

const PlayButton: FC<PlayButtonProps> = ({
  onClick,
  size = PLAY_BUTTON_SIZES.L,
  variant = PLAY_BUTTON_VARIANTS.DEFAULT,
}) => (
  <div
    aria-label={onClick ? "Click to play video" : ""}
    as={onClick ? "button" : undefined}
    className={`PlayButton variant--${variant}`}
    onClick={onClick}
    style={{
      height: `${PLAY_BUTTON_SIZES_DIMENSIONS[size]}px`,
      width: `${PLAY_BUTTON_SIZES_DIMENSIONS[size]}px`,
    }}
  >
    <svg
      width="36"
      height="40"
      viewBox="0 0 36 40"
      fill="none"
      style={{
        width: `${PLAY_BUTTON_SIZES_DIMENSIONS[size] * PLAY_BUTTON_SVG_ASPECT_RATIO}px`,
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.909103 2.39761V37.6046C0.909103 38.8554 1.92244 39.8788 3.16096 39.8788C3.55504 39.8788 3.93504 39.7793 4.28689 39.5803L34.687 21.9697C35.7707 21.3443 36.1366 19.9514 35.5174 18.8711C35.3203 18.5158 35.0248 18.2315 34.687 18.0325L4.28689 0.421923C3.20319 -0.203474 1.82392 0.180293 1.20466 1.26052C1.00762 1.61586 0.909103 1.99963 0.909103 2.39761Z"
        fill={variant === PLAY_BUTTON_VARIANTS.OUTLINE ? "var(--color--action-default)" : "white"}
      />
    </svg>
  </div>
)

export default PlayButton
